<template>
    <SlideIntroLayout class="override" :videoUrl="require('@/assets/vids/intro-4.mp4')" :slideIndex="3" :durationMs="9000" :autoNext="false" nextPageId="AlphaGoat01Tiers" nextButtonTitle="Unpack the Tiers">
        <template #description>
            Six Tiers, Infinite Possibilities
        </template>
    </SlideIntroLayout>
</template>
